import { createSelector } from 'reselect'
import { selectUpcomingInvoice } from './selectUpcomingInvoice'

export const selectUpcomingInvoiceItems = createSelector(
  selectUpcomingInvoice,
  invoice => invoice.lines || []
)
